import type { JobTitle } from '@/types/api'
import { createCrudService } from '../crud'

export type JobTitleInput = Pick<JobTitle, 'name_en' | 'name_ru' | 'name_uz' | 'name_cyr' | 'status'>

export const jobTitlesService = createCrudService<JobTitle, JobTitleInput>('job-titles')
